export const hasMemberPermission = (group, permission = null) => {
    var _a;
    if (!permission) {
        return !!((_a = group === null || group === void 0 ? void 0 : group._auth_relations) === null || _a === void 0 ? void 0 : _a.is_member);
    }
    const permissions = Array.isArray(permission) ? permission : [permission];
    return permissions.some(permission => {
        return group && group._auth_relations &&
            group._auth_relations.permissions &&
            group._auth_relations.permissions.includes(permission);
    });
};
//# sourceMappingURL=permission-helpers.js.map